import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

const basePath = (marinaSlug) =>
  `/manage/${marinaSlug}/point_of_sale/sale_checkouts`

export const getSaleCheckoutsDatatable = (marinaSlug, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(`${basePath(marinaSlug)}${qs}`)
}

export const getSaleCheckoutsSelectableIds = (marinaSlug, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(`${basePath(marinaSlug)}/selectable_ids${qs}`)
}

export const printSaleCheckouts = async (marinaSlug, { ids, ...params }) => {
  const response = await mutateApi({
    url: `${basePath(marinaSlug)}/print`,
    method: "POST",
    data: { ids, ...params },
  })
  return response.data
}

export const exportSaleCheckouts = async (marinaSlug, { ids }) => {
  const response = await mutateApi({
    url: `${basePath(marinaSlug)}/bulk_export`,
    method: "POST",
    data: { ids },
  })
  return response.data
}
